import React, { useState, useCallback, useEffect } from "react";
import ItemGrid from "./OMItemGrid";
import CheckBox from "devextreme-react/check-box";
import data from "../../assets/apiRoutes.json";
import axios from "axios";
import { connect } from "react-redux";
import LotGrid from "./OMLotGrid";
import SublotGrid from "../../wm/components/transactions/inventory/SublotGrid";
import LocationsPopUp from "../../wm/components/transactions/inventory/LocationsPopUp";
import InventoryItemStatusPopUp from "./InventoryItemStatusPopUp";
import InventorySerialNamberPopUp from "../../wm/components/transactions/inventory/InventorySerialNamberPopUp";
import AccordionReact from 'devextreme-react/accordion';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
import TextBox from 'devextreme-react/text-box';
import { createStore } from 'devextreme-aspnet-data-nojquery';

const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];
const OMInventorySearchForm = (props) => {
  var accessToken = props.oidc.user.access_token;
  const [searchPanelStatus, setSearchPanelStatus] = React.useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const selectionChanged = useCallback(
    (e) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => {
        const newStatus = !prevStatus;
        setSearchPanelStatus(newStatus);
      });
    },
    [selectedItems, setSelectedItems],
  );

  const [stateItemObj, setStateItemObj] = useState({});
  const [stateLocPopUp, setstateLocPopUp] = useState(false);
  const [stateStatusPopUp, setStateStatusPopUp] = useState(false);
  const [stateSerialNumberPopUp, setstateSerialNumberPopUp] = useState(false);
  const [locbtnDisable, setlocbtnDisable] = useState(true);
  const [statusbtnDisable, setStatusbtnDisable] = useState(true);
  const [SerialNumberBtnDisable, setSerialNumberBtnDisable] = useState(true);
  const handleItemCallback = (ChildData) => {
    setStateItemObj(ChildData);
  };
  const handleLotCallback = (ChildData) => {
    axios
      .post(`${window._env_.REACT_APP_APIS}/${data.OM.GetItemByRowid}`, { itemRowid: ChildData.itemRowid },
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        res.data.lotRowid = ChildData.lotRowid;
        setStateItemObj(res.data);
        setlocbtnDisable(false);
        setSerialNumberBtnDisable(false);
        setStatusbtnDisable(false);
      });
  };

  const handleSublotCallback = (ChildData) => {
    axios
      .post(`${window._env_.REACT_APP_APIS}/${data.OM.GetItemByRowid}`, { itemRowid: ChildData.itemRowid },
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
            Authorization: `Bearer ${accessToken}`,
          },
        })
      .then((res) => {
        res.data.lotRowid = ChildData.lotRowid;
        res.data.subLotRowid = ChildData.subLotRowid;
        setStateItemObj(res.data);
        setlocbtnDisable(false);
        setSerialNumberBtnDisable(false);
        setStatusbtnDisable(false);
      });
  };

  const handlEnableDisableLocBtn = (ChildData) => {
    setlocbtnDisable(ChildData);
  };
  const handlEnableDisableStatusBtn = (ChildData) => {
    setStatusbtnDisable(ChildData);
  };

  const handlEnableDisableSerialNumberBtn = (ChildData) => {
    setSerialNumberBtnDisable(ChildData);
  };

  const [inventoryItemCodesData, setinventoryItemCodesData] = useState([]);
  const [inventoryItemCodesObj, setinventoryItemCodesObj] = useState({
    itemDescription1: "",
    lotDescription1: "",
    lotCode: "",
    itemCode: "",
    warehouse: "",
    netAvailableGreaterThanZero: false
  });
  const { itemDescription1, lotDescription1, lotCode, itemCode, warehouse, netAvailableGreaterThanZero } =
    inventoryItemCodesObj;
    const [shouldLoadData, setShouldLoadData] = useState(false);

  const handleFieldChange = (name,value) => {
    setinventoryItemCodesObj({
      ...inventoryItemCodesObj,
      [name]: value,
    });
  };

  const onNetAvailableGreaterThanZeroChange = (e) => {
    setinventoryItemCodesObj((inventoryItemCodesObj)=>({
      ...inventoryItemCodesObj,
      netAvailableGreaterThanZero: e.value,
    }))
  };
  const resetItemSearcForm = (e) => {
    e.event.stopPropagation();
    setlocbtnDisable(true);
    setSerialNumberBtnDisable(true);
    setlocbtnDisable(true);
    setinventoryItemCodesObj({
      itemDescription1: "",
      lotDescription1: "",
      lotCode: "",
      itemCode: "",
      warehouse: "",
      netAvailableGreaterThanZero: false
    });
    setShouldLoadData(true);
  };
  useEffect(() => {
    if (shouldLoadData) {
      loadInventoryItemData();
      setShouldLoadData(false);
    }
  }, [shouldLoadData]);
  const loadInventoryItemData = () => {
    var apiMethod = data.OM.GetAllItems;
    if (props.selectedTab === "Lot") {
      apiMethod = data.OM.GetAllLots;
    }
    const resultData = createStore({
      key: 'rowId',
      loadParams:
      {
        itemDescription1: function () {
          return inventoryItemCodesObj.itemDescription1;
        },
        lotDescription1: function () {
          return inventoryItemCodesObj.lotDescription1;
        },
        lotCode: function () {
          return inventoryItemCodesObj.lotCode;
        },
        itemCode: function () {
          return inventoryItemCodesObj.itemCode;
        },
        warehouse: function () {
          return inventoryItemCodesObj.warehouse;
        },
        netAvailableGreaterThanZero: function () {
          return inventoryItemCodesObj.netAvailableGreaterThanZero;
        },
      },
      loadUrl: `${window._env_.REACT_APP_APIS}/${apiMethod}`,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });
    setinventoryItemCodesData(resultData)
  };
  

  const onSubmit = async (e) => {
    e.event.stopPropagation();
    setStateItemObj({});
    setlocbtnDisable(true);
    setSerialNumberBtnDisable(true);
    setlocbtnDisable(true);
    loadInventoryItemData();
  };
  useEffect(() => {
    loadInventoryItemData();
  }, []);


  const handleClosePopUpCallback = (ChildData) => {
    setstateLocPopUp(ChildData);
  };
  const handleStatusPopUpCloseCallback = (ChildData) => {
    setStateStatusPopUp(ChildData);
  };
  const handleSerialNumberClosePopUpCallback = (ChildData) => {
    setstateSerialNumberPopUp(ChildData);
  };

  const openLocations = (e) => {
    if (stateItemObj) {
      setstateLocPopUp(true);
    }
  };
  const openSerialnumberPopUp = (e) => {
    e.preventDefault();
    if (stateItemObj) {
      setstateSerialNumberPopUp(true);
    }
  };
  const openStatus = (e) => {
    if (stateItemObj) {
      setStateStatusPopUp(true);
    }
  };

  return (
    <div className="col-md-12 main-page">
      <form style={{ width: "100%" }}>
        <div>
          <AccordionReact
            dataSource={searchpanel}
            collapsible={true}
            multiple={false}
            animationDuration={300}
            selectedItems={selectedItems}
            onSelectionChanged={selectionChanged}
            itemTitleRender={() => (

              <Toolbar className="accordian-toolbar">
                <Item location="before">
                  <div className="title">
                    <h6
                      style={{
                        color: window._env_.Color2
                      }}
                    >
                      Enter your Query For Inventory {props.selectedTab}s
                    </h6>
                  </div>
                </Item>

                <Item location="after">
                  <Button onClick={(e) => onSubmit(e)} className="accordianButton" text="Search" type="default" />
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={resetItemSearcForm} text="Reset" />
                </Item>


              </Toolbar>
            )}
            itemRender={(itemProps) => (
              <div>
                <div className="row">
                  <div className="col-md-3">
                    <TextBox
                      stylingMode='outlined'
                      labelMode="static"
                      label="Enter Item Code"
                      onValueChanged={(e) => handleFieldChange('itemCode', e.value)}
                      name="itemCode"
                      value={itemCode}
                    />
                  </div>
                  <div className="col-md-3">
                    <TextBox
                      stylingMode='outlined'
                      labelMode="static"
                      label="Enter Lot Code"
                      onValueChanged={(e) => handleFieldChange('lotCode', e.value)}
                      name="lotCode"
                      value={lotCode}
                    />
                  </div>
                  <div className="col-md-3">
                    <TextBox
                      stylingMode='outlined'
                      labelMode="static"
                      label="Enter Item Description"
                      onValueChanged={(e) => handleFieldChange('itemDescription1', e.value)}
                      name="itemDescription1"
                      value={itemDescription1}
                    />
                  </div>
                  <div className="col-md-3">
                    <TextBox
                      stylingMode='outlined'
                      labelMode="static"
                      label="Enter Lot Description"
                      onValueChanged={(e) => handleFieldChange('lotDescription1', e.value)}
                      name="lotDescription1"
                      value={lotDescription1}
                    />
                  </div>
                </div>
                <div className="accordianLastRow row">
                  <div className="col-md-3">
                    <TextBox
                      stylingMode='outlined'
                      labelMode="static"
                      label="Warehouse"
                      onValueChanged={(e) => handleFieldChange('warehouse', e.value)}
                      name="warehouse"
                      value={warehouse}
                    />
                  </div>
                  <div className="col-md-3">
                    <CheckBox
                      onValueChanged={onNetAvailableGreaterThanZeroChange}
                      text="Net Available > 0"
                      className="accordianCheckbox"
                      value={netAvailableGreaterThanZero}
                    />
                  </div>
                </div>
              </div>
            )}
            id="accordion-container" className="accordion-height"
          />
        </div>
      </form>
      {props.selectedTab === "Item" ? (
        <ItemGrid
          data={inventoryItemCodesData}
          accessToken={accessToken}
          parentCallback={handleItemCallback}
          enableDisableLocBtn={handlEnableDisableLocBtn}
          enableDisableSrlNumber={handlEnableDisableSerialNumberBtn}
          enableDisableStatusBtn={handlEnableDisableStatusBtn}
          openLocations={openLocations}
          locbtnDisable={locbtnDisable}
          SerialNumberBtnDisable={SerialNumberBtnDisable}
          openSerialnumberPopUp={openSerialnumberPopUp}
          statusbtnDisable={statusbtnDisable}
          openStatus={openStatus}
          searchPanelStatus={searchPanelStatus}
        />
      ) : props.selectedTab === "Lot" ? (
        <LotGrid data={inventoryItemCodesData}
          accessToken={accessToken}
          parentCallback={handleLotCallback}
          enableDisableLocBtn={handlEnableDisableLocBtn}
          enableDisableSrlNumber={handlEnableDisableSerialNumberBtn}
          enableDisableStatusBtn={handlEnableDisableStatusBtn}
          openLocations={openLocations}
          locbtnDisable={locbtnDisable}
          SerialNumberBtnDisable={SerialNumberBtnDisable}
          openSerialnumberPopUp={openSerialnumberPopUp}
          statusbtnDisable={statusbtnDisable}
          openStatus={openStatus}
          searchPanelStatus={searchPanelStatus}
        />
      ) : props.selectedTab === "Sublot" ? (
        <SublotGrid data={inventoryItemCodesData}
          accessToken={accessToken}
          parentCallback={handleSublotCallback}
          enableDisableLocBtn={handlEnableDisableLocBtn}
          enableDisableSrlNumber={handlEnableDisableSerialNumberBtn}
          enableDisableStatusBtn={handlEnableDisableStatusBtn}
          openLocations={openLocations}
          locbtnDisable={locbtnDisable}
          SerialNumberBtnDisable={SerialNumberBtnDisable}
          openSerialnumberPopUp={openSerialnumberPopUp}
          statusbtnDisable={statusbtnDisable}
          openStatus={openStatus}
          searchPanelStatus={searchPanelStatus}
        />
      ) : ("")
      }
      {stateLocPopUp && (
        <LocationsPopUp
          itemObj={stateItemObj}
          visibility={stateLocPopUp}
          parentCallback={handleClosePopUpCallback}
        ></LocationsPopUp>
      )}
      {stateSerialNumberPopUp && (
        <InventorySerialNamberPopUp
          itemObj={stateItemObj}
          visibility={stateSerialNumberPopUp}
          parentCallback={handleSerialNumberClosePopUpCallback}
        ></InventorySerialNamberPopUp>
      )}
      {stateStatusPopUp && (
        <InventoryItemStatusPopUp
          itemObj={stateItemObj}
          visibility={stateStatusPopUp}
          parentCallback={handleStatusPopUpCloseCallback}
        ></InventoryItemStatusPopUp>
      )}
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(OMInventorySearchForm);
